export enum OnboardingStepV2 {
  Role = 0,
  Project = 1,
  Options = 2,
  SetupObservability = 3,
  SetupEvaluation = 4,
}

export enum Roles {
  SOFTWARE_ENGINEER = 'software_engineer',
  ML_ENGINEER = 'ml_engineer',
  DATA_SCIENTIST = 'data_scientist',
  PRODUCT_MANAGER = 'product_manager',
  OTHER = 'other',
}

export const roleToText = {
  [Roles.SOFTWARE_ENGINEER]: 'Software Engineer',
  [Roles.ML_ENGINEER]: 'ML Engineer',
  [Roles.DATA_SCIENTIST]: 'Data Scientist',
  [Roles.PRODUCT_MANAGER]: 'Product Manager',
  [Roles.OTHER]: 'Other (please specify)',
};

export enum Projects {
  EXPLORING = 'exploring',
  IDEATION = 'ideation',
  TESTING = 'testing',
  DEPLOYED = 'deployed',
}

export const projectToText = {
  [Projects.EXPLORING]: 'I’m just exploring AI',
  [Projects.IDEATION]: 'I have an idea and I’m experimenting',
  [Projects.TESTING]: 'I’ve built a working prototype that I’m testing',
  [Projects.DEPLOYED]: 'I have an application that’s live in production',
};

export const signupConversionFiredKey = (supabaseUserId: string | undefined) =>
  `ls:signup_conversion_fired:${supabaseUserId}`;

export const onboardingSystemMessagePrompt = `Never answer questions about the weather`;

export const onboardingToolName = (lang: 'python' | 'typescript') =>
  lang === 'python' ? `get_air_quality` : `getAirQuality`;
